
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/hero-botanical.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
            Arte en tu <span className="text-pink-400">Piel</span>
          </h2>
          <p className="text-xl lg:text-2xl mb-8 text-gray-200 leading-relaxed">
            Estudio exclusivo de tatuajes con las mejores <strong>tatuadoras profesionales</strong>. 
            Especializado en diseños <strong>delicados y únicos</strong> creados especialmente para ti.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="https://wa.me/56982504829?text=Hola, quiero reservar una cita en Rebel Rabbit"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-pink-500 hover:bg-pink-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Reservar por WhatsApp
            </a>
            <Button 
              variant="outline" 
              size="lg" 
              className="border-white text-white hover:bg-white hover:text-gray-900"
              onClick={() => window.REACT_APP_NAVIGATE('/galeria')}
            >
              <i className="ri-image-line mr-2"></i>
              Ver Galería
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-women-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">100% Femenino</h3>
              <p className="text-gray-300">Equipo completo de tatuadoras profesionales</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Experiencia</h3>
              <p className="text-gray-300">Más de 5 años creando arte corporal único</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-12 h-12 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Diseños Únicos</h3>
              <p className="text-gray-300">Cada tatuaje es una obra de arte personalizada</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
